import { Route, Routes } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import ErrorBoundary from './components/ErrorBoundary';
import AuthProvider from './providers/AuthProvider';
import Profile from './pages/profile';
import './App.css';

const queryClient = new QueryClient();

function App() {
  return (
    <div className="text-denim font-libreBaskerville wisoryapp-container">
      <link
        href="https://fonts.googleapis.com/css?family=IBM+Plex+Sans:bold,bolditalic,italic,normal|IBM+Plex+Serif:italic,normal"
        rel="stylesheet"
      />
      <ErrorBoundary>
        <AuthProvider>
          <QueryClientProvider client={queryClient}>
            <Routes>
              <Route path="/profile/:id" element={<Profile />} />
            </Routes>
          </QueryClientProvider>
        </AuthProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
